import AnPost from 'Style/icons/logos/delivery/AnPost.svg';
import Asendia from 'Style/icons/logos/delivery/Asendia.svg';
import Bpost from 'Style/icons/logos/delivery/Bpost.svg';
import Carreos from 'Style/icons/logos/delivery/Carreos.svg';
import CTT from 'Style/icons/logos/delivery/CTT.svg';
import DeutschePost from 'Style/icons/logos/delivery/DeutschePost.svg';
import DHLExpress from 'Style/icons/logos/delivery/DHLExpress.svg';
import ExpressOne from 'Style/icons/logos/delivery/ExpressOne.svg';
import FanCourier from 'Style/icons/logos/delivery/FanCourier.svg';
import FedExExpress from 'Style/icons/logos/delivery/FedExExpress.svg';
import InPost from 'Style/icons/logos/delivery/InPost.svg';
import LaPoste from 'Style/icons/logos/delivery/LaPoste.svg';
import LatvijasPasts from 'Style/icons/logos/delivery/LatvijasPasts.svg';
import LietuvosPastas from 'Style/icons/logos/delivery/LietuvosPastas.svg';
import MagyarPosta from 'Style/icons/logos/delivery/MagyarPosta.svg';
import Omniva from 'Style/icons/logos/delivery/Omniva.svg';
import OsterreichischePost from 'Style/icons/logos/delivery/OsterreichischePost.svg';
import Packeta from 'Style/icons/logos/delivery/Packeta.svg';
import Posteitaliane from 'Style/icons/logos/delivery/Posteitaliane.svg';
import Posten from 'Style/icons/logos/delivery/Posten.svg';
import Postnl from 'Style/icons/logos/delivery/Postnl.svg';
import Postnord from 'Style/icons/logos/delivery/Postnord.svg';
import RoyalMail from 'Style/icons/logos/delivery/RoyalMail.svg';
import Sameday from 'Style/icons/logos/delivery/Sameday.svg';
import USPS from 'Style/icons/logos/delivery/USPS.svg';
import AMEX from 'Style/icons/logos/payment/AMEX.svg';
import ApplePay from 'Style/icons/logos/payment/ApplePay.svg';
import Bancontact from 'Style/icons/logos/payment/Bancontact.svg';
import Blik from 'Style/icons/logos/payment/Blik.svg';
import CartaSi from 'Style/icons/logos/payment/CartaSi.svg';
import CartesBancaires from 'Style/icons/logos/payment/CartesBancaires.svg';
import Dankort from 'Style/icons/logos/payment/Dankort.svg';
import DotPay from 'Style/icons/logos/payment/DotPay.svg';
import Entercash from 'Style/icons/logos/payment/Entercash.svg';
import Eps from 'Style/icons/logos/payment/Eps.svg';
import Giropay from 'Style/icons/logos/payment/Giropay.svg';
import GooglePay from 'Style/icons/logos/payment/GooglePay.svg';
import iDEAL from 'Style/icons/logos/payment/iDEAL.svg';
import Klarna from 'Style/icons/logos/payment/Klarna.svg';
import Maestro from 'Style/icons/logos/payment/Maestro.svg';
import Mastercard from 'Style/icons/logos/payment/Mastercard.svg';
import MBWAY from 'Style/icons/logos/payment/MBWAY.svg';
import MobilePay from 'Style/icons/logos/payment/MobilePay.svg';
import PayPal from 'Style/icons/logos/payment/PayPal.svg';
import PostePay from 'Style/icons/logos/payment/PostePay.svg';
import Sofort from 'Style/icons/logos/payment/Sofort.svg';
import Trustly from 'Style/icons/logos/payment/Trustly.svg';
import Twint from 'Style/icons/logos/payment/Twint.svg';
import Vipps from 'Style/icons/logos/payment/Vipps.svg';
import Visa from 'Style/icons/logos/payment/Visa.svg';

export const PAYMENT_CARDS = {
    isItemsHorizontal: true,
    items: {
        Visa,
        Mastercard,
        Maestro,
        PayPal,
        GooglePay,
        ApplePay,
        AMEX,
        iDEAL,
        Vipps,
        Klarna,
        Bancontact,
        MBWAY,
        Entercash,
        Giropay,
        CartaSi,
        DotPay,
        Dankort,
        PostePay,
        Trustly,
        Eps,
        Blik,
        MobilePay,
        Sofort,
        Twint,
        CartesBancaires
    }
};

export const DELIVERY_CARDS = {
    isItemsHorizontal: true,
    items: {
        DHLExpress,
        Postnord,
        AnPost,
        Asendia,
        Bpost,
        Carreos,
        CTT,
        DeutschePost,
        ExpressOne,
        FanCourier,
        FedExExpress,
        InPost,
        LaPoste,
        LatvijasPasts,
        LietuvosPastas,
        MagyarPosta,
        Omniva,
        OsterreichischePost,
        Packeta,
        Posteitaliane,
        Posten,
        Postnl,
        RoyalMail,
        Sameday,
        USPS

    }
};
